import type {RetainedUpload} from './uploadTypes.js';

export const originalDigest=async(bytes:ArrayBuffer)=>Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',bytes)),byte=>byte.toString(16).padStart(2,'0')).join('');
/** Independent page-process read; never infer readability from a Blob's size. */
export async function readUploadOriginal(row:Pick<RetainedUpload,'original'|'originalBytes'|'manifest'>,check=()=>{}){
 check();let bytes=row.originalBytes;
 if(!bytes){
  if(!row.original)throw new Error('This device has no readable original for this upload. Keep the saved entry while checking recovery.');
  try{bytes=await row.original.arrayBuffer();}
  catch{
   check();
   try{
    if(typeof FileReader==='undefined')throw new Error('No alternate file reader');
    const original=row.original;
    bytes=await new Promise<ArrayBuffer>((resolve,reject)=>{const reader=new FileReader();reader.onerror=()=>reject(reader.error);reader.onabort=()=>reject(new Error('Original read cancelled'));reader.onload=()=>reader.result instanceof ArrayBuffer?resolve(reader.result):reject(new Error('Original read unavailable'));reader.readAsArrayBuffer(original);});
   }catch{check();throw new Error('Safari cannot read this saved original. No recovery has been confirmed. Keep this upload; do not cancel it or clear app data.');}
  }
 }
 check();
 if(bytes.byteLength!==row.manifest.byteLength||await originalDigest(bytes)!==row.manifest.sha256)throw new Error('This saved original could not be verified. The upload entry has been kept unchanged.');
 check();return bytes;
}

export function presentUpload(row:RetainedUpload):RetainedUpload{
 return !row.original&&row.originalBytes?{...row,original:new Blob([row.originalBytes],{type:row.originalType||'application/octet-stream'})}:row;
}
/** Presentation Blobs must never be written back into the device database. */
export function persistUpload(row:RetainedUpload):RetainedUpload{
 if(!row.original)return {...row,originalBytes:undefined,originalType:undefined};
 return row.originalBytes?{...row,original:undefined}:row;
}
